import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import { replaceCondition, setConditionType } from 'components/Rules/helpers/ruleUpdates';
import RuleConditionShowIfFields from 'components/Rules/RuleConditionShowIf';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly } from 'rtk/questionEditorSelector';
import { conditionTypes, EConditionType } from 'types/rules.types';
import type { TQuestionRule, TQuestionRuleCondition } from 'types/rules.types';

// "Based on another question's answer" is deliberately excluded — it needs a question picker
// scoped to a fixed set of candidate questions (the template's own outline, for the in-template
// editor), and there is no equivalent fixed set for a question edited standalone. Stays
// template-only for now; edit it there once the question is placed.
const STANDALONE_CONDITION_TYPES = conditionTypes.filter((option) => option.value !== EConditionType.QuestionAnswer);

interface Props {
  rule: TQuestionRule;
  condition: TQuestionRuleCondition;
  conditionIdx: number;
}

const RuleConditionShowIf = ({ rule, condition, conditionIdx }: Props) => {
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));

  const commitRule = (nextRule: TQuestionRule) => dispatch(upsertQuestionRule({ questionId, rule: nextRule }));

  return (
    <RuleConditionShowIfFields
      condition={condition}
      isReadOnly={isReadOnly}
      conditionTypeOptions={STANDALONE_CONDITION_TYPES}
      onTypeChange={(type) => commitRule(setConditionType(rule, conditionIdx, type))}
      onChange={(patch) => commitRule(replaceCondition(rule, conditionIdx, patch))}
    />
  );
};

export default RuleConditionShowIf;
